<script setup>
import ContractData from "@/components/generatedOsForm/ContractData.vue";
import TechnicianData from "@/components/generatedOsForm/TechnicianData.vue";
import AdressForm from "@/components/generateOcurrence/AdressForm.vue";
import NapLotadaForm from "@/components/generateOcurrence/NapLotadaForm.vue";
import ProofOfResidenceForm from "@/components/generateOcurrence/ProofOfResidenceForm.vue";
import { isOccurrenceNapLotadaPayload } from "@/utils/constants/occurrenceServiceOptions";
import Stepper from "@/components/stepper/formStepper.vue";
import { showNotifyError } from "@/helpers/notifyHelper";
import LowProductionServices from "@/services/LowProductionServices";
import generateUUIDv4 from "@/utils/generetaUUID.js";
import { onMounted, reactive, ref, computed, nextTick, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import createJsonOccurrence from "../../utils/ResquestOsForms/createJsonOccurrence";
import { getTypeLow } from "../../utils/ResquestOsForms/getTypeOSnameById";
import { VISITA_TECNICA_2 } from "@/utils/constants/typeOs/generateOs";
import moment from "moment-timezone";

const route = useRoute();
const router = useRouter();
const store = useStore();

let isLoading = ref(false);
let toggleLoading = () => (isLoading.value = !isLoading.value);

const lowProductionServices = new LowProductionServices();
const listActionOptionsFilterByIdTypeOs = ["7", "8"];
let osTypesWithAttendanceClock = [VISITA_TECNICA_2];
const VALUE_MAX_BAR_PROGRESS = 1;

const optionsItens = reactive({
  optionsAccredited: [],
  optionsCity: [],
  optionsCodCity: [],
  optionsTypeOS: [],
  optionsWriteOffCode: [],
  optionsActionOs: [],
  equipamentsOS: [],
  generateOptions: [],
});

let formScheme = ref({
  accredited: "",
  numberPhone: "",
  contractNumber: "",
  optionsAccredited: "",
  codeCity: null,
  city: null,
  contractOs: null,
  dateStartedAttendance: moment()
    .tz("America/Sao_Paulo")
    .format("YYYY-MM-DD HH:mm:ss"),
  dateFinishedAttendance: moment()
    .tz("America/Sao_Paulo")
    .format("YYYY-MM-DD HH:mm:ss"),
  solicitations: [],
  napInstallation: "",
  napCustomer: "",
  occurrenceAddress: {
    customerName: "",
    streetAddressOS: "",
    numberAddressOS: "",
    additionalInformationAddressOS: "",
    neighborhoodAddressOS: "",
    zipCodeAddressOS: "",
    streetProofOfAddress: "",
    numberProofOfAddress: "",
    additionalInformationProofOfAddress: "",
    neighborhoodProofOfAddress: "",
    zipCodeProofOfAddress: "",
  },
});
/** Refs por aba — evita índice errado quando o painel inativo não monta o filho. */
const tabFormRefs = ref({});
function setTabFormRef(labelTab, el) {
  // Não limpar quando el === null: painéis inativos desmontam mas os dados seguem no formScheme;
  // com keep-alive no q-tab-panels a instância costuma permanecer válida para validateForm.
  // Só atualizar se a instância mudou — evita novo objeto a cada render e possível loop de ref.
  if (el && tabFormRefs.value[labelTab] !== el) {
    tabFormRefs.value = { ...tabFormRefs.value, [labelTab]: el };
  }
}

// type RouteParam = string | string[] | undefined | null;

function routeParamSingle(v) {
  if (v == null) return "";
  return Array.isArray(v) ? (v[0] ?? "") : String(v);
}

// type AttendanceRouteInfo = { os_type?: string | string[]; name_type?: string | string[] };
let attendanceOption = ref({});

function attendanceOsTypeRaw() {
  return routeParamSingle(attendanceOption.value.os_type);
}

let formList = ref([]);
let panelList = ref([]);
let panel = ref("tab-1");
let progressBar = ref(0);
let isShowProgressBar = ref(true);
let isDisabled = ref(false);

let schemeSolicitation = {
  object_id: generateUUIDv4(),
  osNumber: "",
  typeOS: null,
  movimentTerminal: 0,
  writeOffCode: null,
  action: null,
  state: null,
  observation: "",
  equipamentNumberInstall: "",
  IsDecoderComum: false,
  cardNumberInstaled: "",
};

const optionsPanelAddressCorrection = [
  { label: "tab-1", value: "tab-1" },
  { label: "tab-2", value: "tab-2" },
  { label: "tab-3", value: "tab-3" },
  { label: "tab-4", value: "tab-4" },
];

const componentsAddressCorrection = {
  "tab-1": TechnicianData,
  "tab-2": ContractData,
  "tab-3": AdressForm,
  "tab-4": ProofOfResidenceForm,
};

const optionsPanelNapLotada = [
  { label: "tab-1", value: "tab-1" },
  { label: "tab-2", value: "tab-2" },
  { label: "tab-3", value: "tab-3" },
];

const componentsNapLotada = {
  "tab-1": TechnicianData,
  "tab-2": ContractData,
  "tab-3": NapLotadaForm,
};

const isVisitaTecnica2 = computed(() => {
  return Number(attendanceOsTypeRaw()) === VISITA_TECNICA_2;
});

function _handleFormByTypeOs() {
  attendanceOption.value = { ...route.params, ...route.query };
  const serviceOptionId = routeParamSingle(route.query.os_type);
  const isNapLotada = isOccurrenceNapLotadaPayload(serviceOptionId);

  const panelMeta = isNapLotada
    ? optionsPanelNapLotada
    : optionsPanelAddressCorrection;
  const componentMap = isNapLotada
    ? componentsNapLotada
    : componentsAddressCorrection;

  const mappedOptions = panelMeta.map((item) => ({
    labelTab: item.label,
    component: componentMap[item.label],
  }));

  panelList.value = panelMeta;
  formList.value = mappedOptions;
  progressBar.value = 1 / formList.value.length;
}

watch(
  () => route.query.os_type,
  () => {
    panel.value = "tab-1";
    tabFormRefs.value = {};
    _handleFormByTypeOs();
  },
);

function disabledtabButton(value) {
  isShowProgressBar.value = value;
}

function redirectToServiceHistory() {
  let token = localStorage.getItem("access_token");
  router.replace({
    name: "service-history",
    query: { access_token: token },
  });
}

function changePanelTabValue() {
  const VALUE_ADD_PROGRESS = 1 / formList.value.length;

  let number = _getNextProgressPageNumber();
  panel.value = `tab-${number}`;

  if (progressBar.value != VALUE_MAX_BAR_PROGRESS) {
    progressBar.value += VALUE_ADD_PROGRESS;
  }
}

async function addValueBarProgressAndAlterTab() {
  await nextTick();
  const refEl = tabFormRefs.value[panel.value];
  if (!refEl || typeof refEl.validateForm !== "function") {
    showNotifyError("Não foi possível validar esta etapa. Tente novamente.");
    return;
  }
  if (await refEl.validateForm()) {
    changePanelTabValue();
  }
}

function _getNextProgressPageNumber() {
  let panelSplited = panel.value.split("-");

  return parseInt(panelSplited.slice(-1).pop(), 10) + 1;
}

async function _getCitiesActives() {
  await lowProductionServices.getCitiesActives().then((response) => {
    optionsItens.optionsCity = response;
    optionsItens.optionsCodCity = response;
  });
}

function _getAccreditedsActives() {
  lowProductionServices.getAccreditedsActives().then((response) => {
    optionsItens.optionsAccredited = response;
  });
}

function _getTypeOsByServiceOption() {
  lowProductionServices
    .getTypeOsByServiceOption(attendanceOsTypeRaw())
    .then((response) => {
      optionsItens.optionsTypeOS = response;
    });
}

function getWriteOffCodeByLowType(actionId = null) {
  let typeOs = getTypeLow(9, actionId);
  if (isVisitaTecnica2.value) {
    return;
  }
  // getTypeLow(9, null) não cobre nenhum branch — sem isso a API recebe low_type=undefined e pode falhar ou travar em alguns ambientes.
  if (typeOs == null) {
    return;
  }
  lowProductionServices.getWriteOffCodeByLowType(typeOs).then((response) => {
    optionsItens.optionsWriteOffCode = response;
  });
}

function getAllWriteOffActives() {
  lowProductionServices.getWriteOffCodeActives().then((response) => {
    optionsItens.optionsWriteOffCode = response.filter((item) => {
      return item.value === 530;
    });
  });
}

function getTypeOsGenerate(attendanceId) {
  lowProductionServices
    .getTypeOsById(attendanceOsTypeRaw(), attendanceId)
    .then((response) => {
      optionsItens.generateOptions = response;
    });
}

function _getDefaultTechnicianData() {
  formScheme.value.accredited = store.state.accredited;
  formScheme.value.numberPhone = store.state.numberPhone;

  if (store.state.addressCity != "") {
    lowProductionServices
      .getCodeCityByName(store.state.addressCity)
      .then((response) => {
        formScheme.value.codeCity = {
          text: response.cidade,
          value: response.codcidadenetsms,
        };
        formScheme.value.city = {
          text: response.cidade,
          value: response.codcidadenetsms,
        };
      });
  }
}

function _getWriteOffCodes() {
  if (isVisitaTecnica2.value) {
    getAllWriteOffActives();
  } else {
    getWriteOffCodeByLowType();
  }
}

function _serviceOptionIdForOccurrence() {
  return (
    routeParamSingle(route.query.os_type) ||
    routeParamSingle(route.params.os_type)
  );
}

async function validateAllOccurrenceSteps() {
  await nextTick();
  for (let i = 0; i < formList.value.length; i++) {
    const labelTab = formList.value[i].labelTab;
    const step = tabFormRefs.value[labelTab];
    if (!step || typeof step.validateForm !== "function") {
      showNotifyError("Não foi possível validar todas as etapas.");
      return false;
    }
    if (!(await step.validateForm())) {
      panel.value = labelTab;
      const add = 1 / formList.value.length;
      progressBar.value = Math.min(1, add * (i + 1));
      return false;
    }
  }
  return true;
}

async function createGenerateOs() {
  if (!(await validateAllOccurrenceSteps())) {
    return;
  }

  const payload = createJsonOccurrence(
    formScheme.value,
    _serviceOptionIdForOccurrence(),
  );

  console.log("[occurrence payload]", JSON.stringify(payload, null, 2));

  toggleLoading();
  await lowProductionServices
    .saveGenerateOs(payload)
    .then(() => {
      redirectToServiceHistory();
      toggleLoading();
    })
    .catch((error) => {
      toggleLoading();
      if (error.response && error.response.data) {
        isDisabled.value = true;
        showNotifyError(error.response.data);
      } else {
        showNotifyError("Erro ao gerar OS. Por favor refaça o formulário");
      }
    });
}

async function finishAttendance() {
  const isLastStep = panel.value == `tab-${formList.value.length}`;

  if (!isLastStep) {
    return;
  }

  await createGenerateOs();
}

onMounted(() => {
  _handleFormByTypeOs();
  _getDefaultTechnicianData();
  _getAccreditedsActives();
  _getCitiesActives();
  _getTypeOsByServiceOption();
  _getWriteOffCodes();
});

// Expose values and functions for template usage
defineExpose({
  ContractData,
  formList,
  panelList,
  panel,
  formScheme,
  optionsItens,
  progressBar,
  isShowProgressBar,
  schemeSolicitation,
  tabFormRefs,
  attendanceOption,
  disabledtabButton,
  addValueBarProgressAndAlterTab,
  finishAttendance,
  getWriteOffCodeByLowType,
  isLoading,
  changePanelTabValue,
  isDisabled,
  VALUE_MAX_BAR_PROGRESS,
  getTypeOsGenerate,
  VISITA_TECNICA_2,
  getAllWriteOffActives,
});
</script>

<template>
  <q-page-container>
    <q-page class="">
      <section class="section-service-stepper">
        <q-option-group hidden v-model="panel" inline :options="panelList" />
        <q-tab-panels v-model="panel" class="step-panels" keep-alive>
          <q-tab-panel
            class="panel-item"
            v-for="panelItem in formList"
            :key="panelItem.labelTab"
            :name="panelItem.labelTab"
          >
            <component
              :ref="(el) => setTabFormRef(panelItem.labelTab, el)"
              :itemOsContract="schemeSolicitation"
              :typeOs="attendanceOption"
              :is="panelItem.component"
              :contract="formScheme"
              :optionsItens="optionsItens"
              :force-show-contract-number="true"
              @disabledtabButton="(value) => disabledtabButton(value)"
              @getTypeOsClassification="
                (value) => getWriteOffCodeByLowType(value)
              "
              @getTypeOsGenerate="(value) => getTypeOsGenerate(value)"
            />
          </q-tab-panel>
        </q-tab-panels>
        <div>
          <Stepper
            v-if="isShowProgressBar"
            :progressBarValue="progressBar"
            :maxValue="VALUE_MAX_BAR_PROGRESS"
            :finishFn="finishAttendance"
            :nextTabFn="addValueBarProgressAndAlterTab"
            :isLoading="isLoading"
            :isDisabled="isDisabled"
          />
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<style lang="scss">
section-service-stepper {
  display: flex;
  height: 100vh;
  width: 100vw;
}

.step-panels {
  background: transparent !important;
  overflow: hidden !important;
  display: flex;

  .panel-item {
    width: 100%;
    // padding-right: 15px;
  }
}

.title-page {
  font-weight: bold;
  font-size: 18px;
  line-height: 19px;
  text-transform: uppercase;
  color: #e2262d;
}

label {
  font-weight: bold;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>
